import {
  ApartmentOutlined,
  AuditOutlined,
  ClusterOutlined,
  ContainerOutlined,
  FileProtectOutlined,
  FileTextOutlined,
  IdcardOutlined,
  ReconciliationOutlined,
  SettingOutlined,
} from '@ant-design/icons';

import {
  ClaimMenuIcon,
  DashboardCbsIcon,
  LostFoundMenuIcon,
  LostItemMenuIcon,
  MessagesCbsIcon,
  RefundMenuIcon,
} from 'assets/svg';
import { AudioLines, ChartColumnStacked, Earth } from 'lucide-react';

const RouteList = {
  'incident-management': [
    // {
    //   name_th: 'เรียกคิว',
    //   name_en: 'Queue',
    //   icon: <TeamOutlined />,
    //   path: `/app/incident-management/queue-access`,
    //   query: {
    //     group: 'queue_management',
    //     type: 'คิว',
    //   },
    // },
    {
      name_th: 'รายงาน',
      name_en: 'Report',
      icon: <ReconciliationOutlined style={{ marginRight: 0 }} />,
      path: `/app/incident-management/report`,
      query: {
        group: 'Incident Management',
      },
      children: [
        // {
        //   name_th: 'รายงานประจำวัน',
        //   name_en: 'Daily Report',
        //   icon: <FileDoneOutlined />,
        //   path: '/daily',
        //   query: {
        //     group: 'Incident Management',
        //     type: 'รายงานประจำวัน',
        //   },
        // },
        // {
        //   name_th: 'รายงานภายในองค์กร',
        //   name_en: 'Internal Report',
        //   icon: <AuditOutlined />,
        //   path: '/internal',
        //   query: {
        //     group: 'Incident Management',
        //     type: 'รายงานภายในองค์กร',
        //   },
        // },
        {
          name_th: 'รายงานแจ้งเหตุออนไลน์',
          name_en: 'Online Incident Report',
          icon: <FileProtectOutlined />,
          path: '/online',
          query: {
            group: 'Incident Management',
            type: 'รายงานการแจ้งเหตุออนไลน์',
          },
        },
        // {
        //   name: 'รายงานจากเว็บฟอร์ม',
        //   icon: <ExceptionOutlined />,
        //   path: '/webform',
        //   query: {
        //     group: 'Incident Management',
        //     type: 'รายงานจากเว็บฟอร์ม',
        //   },
        // },
        // {
        //   name: 'รายงานการปฏิบัติหน้าที่',
        //   icon: <SolutionOutlined />,
        //   path: '/onduty',
        //   query: {
        //     group: 'Incident Management',
        //     type: 'รายงานการปฏิบัติหน้าที่',
        //   },
        // },
        // {
        //   name: 'รายงานรับแจ้งเหตุ 191',
        //   icon: <FileProtectOutlined />,
        //   path: '/191',
        //   query: {
        //     group: 'Incident Management',
        //     type: 'รายงานรับแจ้งเหตุ 191',
        //   },
        // },
      ],
    },
    // {
    //   name: 'ประเภทรายงาน',
    //   icon: <GroupOutlined />,
    //   path: '/app/incident-management/setting/genre',
    //   query: {
    //     group: 'Incident Management',
    //     type: 'ประเภทรายงาน',
    //   },
    // },
    // {
    //   name: 'ตั้งค่าเว็บฟอร์ม',
    //   icon: <SettingOutlined />,
    //   path: '/app/incident-management/setting/webform',
    //   query: {
    //     group: 'Incident Management',
    //     type: 'เว็บฟอร์ม',
    //   },
    // },
    // {
    //   name: 'รหัส ความผิด/เหตุการณ์',
    //   icon: <LockOutlined />,
    //   path: '/app/incident-management/setting/identities-code',
    //   query: {
    //     group: 'Incident Management',
    //     type: 'รหัสความผิด',
    //   },
    // },
    // {
    //   name: "นำเข้าข้อมูล",
    //   icon: <DownloadOutlined />,
    //   path: `/app/incident-management/import-report`,
    //   query: {
    //     group: "incident_management",
    //   },
    // },
  ],
  personnel: [
    {
      name_th: 'กำลังพล',
      name_en: 'Personnel',
      icon: <IdcardOutlined />,
      path: '/app/personnel',
      query: {
        group: 'Personnel',
        type: 'กำลังพล',
      },
    },
    // {
    //   name: 'ตารางปฏิบัติหน้าที่',
    //   icon: <CalendarOutlined />,
    //   path: '/app/personnel/schedule',
    //   query: {
    //     group: 'Personnel',
    //     type: 'ตารางปฏิบัติหน้าที่',
    //   },
    // },
    // {
    //   name: 'ชุดปฏิบัติการ',
    //   icon: <TeamOutlined />,
    //   path: '/app/personnel/team',
    //   query: {
    //     group: 'Personnel',
    //     type: 'ชุดปฏิบัติการ',
    //   },
    // },
    // {
    //   name: 'แผนผังภายในองค์กร',
    //   icon: <ApartmentOutlined />,
    //   path: '/app/personnel/organize-chart',
    //   query: {
    //     group: 'Personnel',
    //     type: 'กำลังพล',
    //   },
    // },
    // {
    //   name: 'นำเข้าข้อมูล',
    //   icon: <DownloadOutlined />,
    //   path: '/app/personnel/import-report-force',
    //   query: {
    //     group: 'Personnel',
    //     type: 'กำลังพล',
    //     name: 'แก้ไขข้อมูลกำลังพล',
    //   },
    // },
    {
      name_th: 'ตั้งค่า',
      name_en: 'Settings',
      icon: <SettingOutlined />,
      path: '/app/personnel/setting',
      query: {
        group: 'Personnel',
        type: ['ตำแหน่ง', 'ฝ่ายงาน'],
      },
      children: [
        {
          name_th: 'ตำแหน่ง',
          name_en: 'Position',
          icon: <ApartmentOutlined />,
          path: '/position',
          query: {
            group: 'Personnel',
            type: 'ตำแหน่ง',
          },
        },
        {
          name_th: 'ฝ่ายงาน',
          name_en: 'Department',
          icon: <ClusterOutlined />,
          path: '/department',
          query: {
            group: 'Personnel',
            type: 'ฝ่ายงาน',
          },
        },
        // {
        //   name: 'องค์กร',
        //   icon: <BankOutlined />,
        //   path: '/organization',
        //   query: {
        //     group: 'Personnel',
        //     type: 'กำลังพล',
        //   },
        // },
      ],
    },
  ],
  poi: [
    {
      name_th: 'แดชบอร์ด',
      name_en: 'Dashboard',
      icon: <IdcardOutlined />,
      path: '/app/poi',
    },
    {
      name_th: 'พื้นที่รับผิดชอบ',
      name_en: 'Responsible Area',
      icon: <IdcardOutlined />,
      path: '/app/poi/place-mornitor',
    },
    {
      name_th: 'ผู้รับผิดชอบแต่ละพื้นที่',
      name_en: 'Area Responsible Person',
      icon: <IdcardOutlined />,
      path: '/app/poi/',
    },
    {
      name_th: 'ข้อมูลสารสนเทศภูมิศาสตร์',
      name_en: 'Geographic Information',
      icon: <IdcardOutlined />,
      path: '/app/poi/',
    },
  ],
  'mass-notification': [
    {
      name_th: 'การแจ้งเตือนมวลชน',
      name_en: 'Mass Notification',
      icon: <AuditOutlined />,
      path: '/app/one-command/mass-notification',
      query: {
        group: 'mass-notification',
      },
    },
    {
      name_th: 'ตั้งค่า',
      name_en: 'Settings',
      icon: <SettingOutlined />,
      path: '/app/one-command/mass-notification',
      query: {
        group: 'mass-notification',
      },
      children: [
        {
          name_th: 'ประเภทการเตือน',
          name_en: 'Alert Type',
          icon: <ContainerOutlined />,
          path: '/setting',
          query: {
            group: 'mass-notification',
          },
        },
      ],
    },
  ],
  cbs: [
    {
      name_th: 'แดชบอร์ด',
      name_en: 'Dashboard',
      icon: (
        <span className="anticon">
          <DashboardCbsIcon width={14} height={14} />
        </span>
      ),
      path: '/app/one-command/cbs',
    },
    {
      name_th: 'รายการข้อความ',
      name_en: 'Message List',
      icon: (
        <span className="anticon">
          <MessagesCbsIcon width={14} height={15} />
        </span>
      ),
      path: '/app/one-command/cbs/list',
    },
    {
      name_th: 'การตั้งค่า',
      name_en: 'Settings',
      icon: <SettingOutlined />,
      path: '/app/one-command/cbs/setting',

      children: [
        {
          name_th: 'ข้อมูลหลัก',
          name_en: 'Master Data',
          icon: <ContainerOutlined />,
          path: '/master-data',
        },
      ],
    },
  ],
  'online-scam': [
    {
      name_th: 'ภาพรวมคดี',
      name_en: 'Case Overview',
      icon: (
        <span className="anticon">
          <ChartColumnStacked width={14} height={14} />
        </span>
      ),
      path: '/app/online-scam/dashboard',
      query: {
        group: 'Online Scam',
        // name: '',
      },
    },
    {
      name_th: 'คดีออนไลน์',
      name_en: 'Online Cases',
      icon: (
        <span className="anticon">
          <Earth width={14} height={14} />
        </span>
      ),
      path: '/app/online-scam',
      query: {
        group: 'Online Scam',
        // name: '',
      },
    },
    {
      name_th: 'ระบบถอดเสียงการสอบปากคำ',
      name_en: 'Interrogation Transcription System',
      icon: (
        <span className="anticon">
          <AudioLines width={14} height={15} />
        </span>
      ),
      path: '/app/online-scam/voice',
      query: {
        group: 'Online Scam',
        // name: '',
      },
    },
    {
      name_th: 'สร้างเอกสาร',
      name_en: 'Create Document',
      icon: <FileTextOutlined />,
      path: '/app/online-scam/document',
      query: {
        group: 'Online Scam',
        // name: '',
      },
      // children: [
      //   {
      //     name_th: 'เอกสารทั้งหมด',
      //     name_en: 'All Documents',
      //     icon: <FileTextOutlined />,
      //     path: '/all',
      //   },
      //   {
      //     name_th: DOCUMENT_OPTIONS.documentSummons.title,
      //     name_en: DOCUMENT_OPTIONS.documentSummons.titleEn,
      //     icon: <FileTextOutlined />,
      //     path: DOCUMENT_OPTIONS.documentSummons.childPath,
      //   },
      //   {
      //     name_th: DOCUMENT_OPTIONS.witnessSummons.title,
      //     name_en: DOCUMENT_OPTIONS.witnessSummons.titleEn,
      //     icon: <FileTextOutlined />,
      //     path: DOCUMENT_OPTIONS.witnessSummons.childPath,
      //   },
      //   {
      //     name_th: DOCUMENT_OPTIONS.investigationReport.title,
      //     name_en: DOCUMENT_OPTIONS.investigationReport.titleEn,
      //     icon: <FileTextOutlined />,
      //     path: DOCUMENT_OPTIONS.investigationReport.childPath,
      //   },
      //   {
      //     name_th: DOCUMENT_OPTIONS.stolenPropertyList.title,
      //     name_en: DOCUMENT_OPTIONS.stolenPropertyList.titleEn,
      //     icon: <FileTextOutlined />,
      //     path: DOCUMENT_OPTIONS.stolenPropertyList.childPath,
      //   },
      //   {
      //     name_th: DOCUMENT_OPTIONS.inquiryNote.title,
      //     name_en: DOCUMENT_OPTIONS.inquiryNote.titleEn,
      //     icon: <FileTextOutlined />,
      //     path: DOCUMENT_OPTIONS.inquiryNote.childPath,
      //   },
      //   {
      //     name_th: DOCUMENT_OPTIONS.chargeNotification.title,
      //     name_en: DOCUMENT_OPTIONS.chargeNotification.titleEn,
      //     icon: <FileTextOutlined />,
      //     path: DOCUMENT_OPTIONS.chargeNotification.childPath,
      //   },
      //   {
      //     name_th: DOCUMENT_OPTIONS.remandRequest.title,
      //     name_en: DOCUMENT_OPTIONS.remandRequest.titleEn,
      //     icon: <FileTextOutlined />,
      //     path: DOCUMENT_OPTIONS.remandRequest.childPath,
      //   },
      //   {
      //     name_th: DOCUMENT_OPTIONS.warrantRequest.title,
      //     name_en: DOCUMENT_OPTIONS.warrantRequest.titleEn,
      //     icon: <FileTextOutlined />,
      //     path: DOCUMENT_OPTIONS.warrantRequest.childPath,
      //   },
      //   {
      //     name_th: DOCUMENT_OPTIONS.inquiryTransfer.title,
      //     name_en: DOCUMENT_OPTIONS.inquiryTransfer.titleEn,
      //     icon: <FileTextOutlined />,
      //     path: DOCUMENT_OPTIONS.inquiryTransfer.childPath,
      //   },
      //   {
      //     name_th: DOCUMENT_OPTIONS.inquiryReport.title,
      //     name_en: DOCUMENT_OPTIONS.inquiryReport.titleEn,
      //     icon: <FileTextOutlined />,
      //     path: DOCUMENT_OPTIONS.inquiryReport.childPath,
      //   },
      //   {
      //     name_th: DOCUMENT_OPTIONS.caseFileIndex.title,
      //     name_en: DOCUMENT_OPTIONS.caseFileIndex.titleEn,
      //     icon: <FileTextOutlined />,
      //     path: DOCUMENT_OPTIONS.caseFileIndex.childPath,
      //   },
      //   {
      //     name_th: DOCUMENT_OPTIONS.caseSubmission.title,
      //     name_en: DOCUMENT_OPTIONS.caseSubmission.titleEn,
      //     icon: <FileTextOutlined />,
      //     path: DOCUMENT_OPTIONS.caseSubmission.childPath,
      //   },
      // ],
    },
  ],
  'lost-found-management': [
    {
      name_th: 'Lost & Found Management',
      name_en: 'Lost & Found Management',
      icon: (
        <span className="anticon">
          <LostFoundMenuIcon width={14} height={14} />
        </span>
      ),
      path: '/app/lost-found-management',
    },
    {
      name_th: 'รายการแจ้งของหาย',
      name_en: 'รายการแจ้งของหาย',
      icon: (
        <span className="anticon">
          <LostItemMenuIcon width={14} height={14} />
        </span>
      ),
      path: '/app/lost-found-management/lost-report',
    },
    {
      name_th: 'รายการขอเคลม',
      name_en: 'รายการขอเคลม',
      icon: (
        <span className="anticon">
          <ClaimMenuIcon width={14} height={14} />
        </span>
      ),
      path: '/app/lost-found-management/claim',
    },
    {
      name_th: 'รายการคืน',
      name_en: 'รายการคืน',
      icon: (
        <span className="anticon">
          <RefundMenuIcon width={14} height={14} />
        </span>
      ),
      path: '/app/lost-found-management/refund',
    },
  ],
};

export default RouteList;
